<template> 
  <div> 
	<div class="d-flex flex-column flex-root"> 
		<div class="d-flex flex-column flex-column-fluid">
			<div class="d-flex flex-column text-center">
				<div class="card card-flush py-5">
					<div class="card-body py-15 py-lg-20" v-if="this.$isAdmin() && userData.is_pending_licence_exist == 0 && (userData.csrde !== 1 && userData.is_lic_active == 1) !== 1">
						<h1 class="fw-bolder fs-2qx text-gray-900 mb-4"><i class="bi bi-hourglass-bottom fs-2x text-danger"></i>  {{ $t('your_plan_is_expired') }} </h1>
						<div class="fw-semibold fs-6 text-gray-500 mb-7"> {{ $t('you_can_upgrade_or') }} </div>
						<div class="mb-10">
							<a href="#" class="btn btn-warning text-dark fw-bolder fs-8" data-bs-toggle="modal" data-bs-target="#kt_modal_upgrade_plan" @click="openUpgradeModal()">
								<span class="svg-icon svg-icon-2 text-dark">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path opacity="0.3" d="M4.05424 15.1982C8.34524 7.76818 13.5782 3.26318 20.9282 2.01418C21.0729 1.98837 21.2216 1.99789 21.3618 2.04193C21.502 2.08597 21.6294 2.16323 21.7333 2.26712C21.8372 2.37101 21.9144 2.49846 21.9585 2.63863C22.0025 2.7788 22.012 2.92754 21.9862 3.07218C20.7372 10.4222 16.2322 15.6552 8.80224 19.9462L4.05424 15.1982ZM3.81924 17.3372L2.63324 20.4482C2.58427 20.5765 2.5735 20.7163 2.6022 20.8507C2.63091 20.9851 2.69788 21.1082 2.79503 21.2054C2.89218 21.3025 3.01536 21.3695 3.14972 21.3982C3.28408 21.4269 3.42387 21.4161 3.55224 21.3672L6.66524 20.1802L3.81924 17.3372ZM16.5002 5.99818C16.2036 5.99818 15.9136 6.08615 15.6669 6.25097C15.4202 6.41579 15.228 6.65006 15.1144 6.92415C15.0009 7.19824 14.9712 7.49984 15.0291 7.79081C15.0869 8.08178 15.2298 8.34906 15.4396 8.55884C15.6494 8.76862 15.9166 8.91148 16.2076 8.96935C16.4986 9.02723 16.8002 8.99753 17.0743 8.884C17.3484 8.77046 17.5826 8.5782 17.7474 8.33153C17.9123 8.08486 18.0002 7.79485 18.0002 7.49818C18.0002 7.10035 17.8422 6.71882 17.5609 6.43752C17.2796 6.15621 16.8981 5.99818 16.5002 5.99818Z" fill="currentColor"/>
									<path d="M4.05423 15.1982L2.24723 13.3912C2.15505 13.299 2.08547 13.1867 2.04395 13.0632C2.00243 12.9396 1.9901 12.8081 2.00793 12.679C2.02575 12.5498 2.07325 12.4266 2.14669 12.3189C2.22013 12.2112 2.31752 12.1219 2.43123 12.0582L9.15323 8.28918C7.17353 10.3717 5.4607 12.6926 4.05423 15.1982ZM8.80023 19.9442L10.6072 21.7512C10.6994 21.8434 10.8117 21.9129 10.9352 21.9545C11.0588 21.996 11.1903 22.0083 11.3195 21.9905C11.4486 21.9727 11.5718 21.9252 11.6795 21.8517C11.7872 21.7783 11.8765 21.6809 11.9402 21.5672L15.7092 14.8442C13.6269 16.8245 11.3061 18.5377 8.80023 19.9442ZM7.04023 18.1832L12.5832 12.6402C12.7381 12.4759 12.8228 12.2577 12.8195 12.032C12.8161 11.8063 12.725 11.5907 12.5653 11.4311C12.4057 11.2714 12.1901 11.1803 11.9644 11.1769C11.7387 11.1736 11.5205 11.2583 11.3562 11.4132L5.81323 16.9562L7.04023 18.1832Z" fill="currentColor"/>
									</svg>
								</span>
								<span v-if="userData.package_type > 1 && userData.period_end <= 30">
									{{ $t('renew_your_plan') }}
								</span>
								<span v-else>
									{{ $t('upgrade_your_plan') }}
								</span>
							</a>
						</div>
						<div class="mb-11">
							<img src="/assets/theme/media/illustrations/unitedpalms-1/1.png" class="mw-100 mh-300px theme-light-show" alt="">
							<img src="/assets/theme/media/illustrations/unitedpalms-1/1-dark.png" class="mw-100 mh-300px theme-dark-show" alt="">
						</div>
					</div>
					<div class="card-body" v-if="userData.is_pending_licence_exist > 0 && (userData.csrde !== 1 && userData.is_lic_active == 1) !== 1">
						<h1 class="fw-bolder fs-2qx text-gray-900 mb-4"> <i class="bi bi-hourglass-bottom fs-2x text-danger"></i>  {{ $t('your_plan_is_expired') }}  </h1>
						<div class="separator"></div>
						
                        <div class="d-flex flex-column ms-5 my-5 text-start">
                            <h3 class="mb-1 mt-5"> {{ $t('you_have_pending_requests') }} </h3>
                            <span class="fs-6 mb-5">
                                 {{ $t('payment_is') }} 
                            </span>
                        </div>
						
						<div class="table-responsive mt-10">
                            <table class="table table-row-bordered border align-middle gy-5 gs-3">
                                <thead class="border-bottom border-gray-200 fs-6 text-gray-700 fw-bold bg-light bg-opacity-75">
                                    <tr>
                                        <td class="text-start"> {{ $t('date') }} </td>
                                        <td class="text-start mw-200px"> {{ $t('plan_name') }} </td>
                                        <td class="text-start"> {{ $t('payment_type') }} </td>
                                        <td class="text-start"> {{ $t('payment_method') }} </td>
                                        <td class="text-end"> {{ $t('price') }} </td>
                                        <td class="text-end"> {{ $t('vat') }} </td>
                                        <td class="text-end"> {{ $t('grand_total') }} </td>
                                        <td class="text-end"> {{ $t('reference_number') }} </td>
                                        <td class="text-end"></td>
                                    </tr>
                                </thead>
                                <tbody class="fw-semibold fs-6 text-gray-700">
                                    <tr v-for="(item, index) in pendingLicencesList" v-bind:key="item">
                                        <td class="text-start">{{previewDate(item.created_at)}}</td>
                                        <td class="text-start">
                                            {{ $t('licences.' + item.description) }}
                                            <span v-if="item.user_count > 0"> (+{{item.user_count}} User)</span>
                                        </td>
                                        <td class="text-start">{{item.payment_type_name}}</td>
                                        <td class="text-start">{{item.payment_method_name}}</td>
                                        <td class="text-end">{{item.price}}</td>
                                        <td class="text-end">{{item.vat_amount}}</td>
                                        <td class="text-end text-gray-800 fw-bolder">{{item.grand_total}} {{userData.currency_code}} </td>
                                        <td class="text-end text-gray-800 fw-bolder">{{item.licence_reference_number}}</td>
                                        <td class="text-end">
                                            <button v-if="item.payment_method == 1 && index == 0" class="btn btn-success btn-xs" type="button" data-bs-toggle="modal" 
                                                data-bs-target="#kt_modal_upgrade_plan" @click="openUpgradeModal(true, item)"> 
                                                 {{ $t('complete_the_payment') }} 
                                            </button>
                                            <button v-if="index == 0" class="btn btn-danger btn-xs" type="button" @click="onCancelLicenceRequest(item)"> 
                                                 {{ $t('cancel_request') }} 
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
						</div>
						<div>
							<img src="/assets/theme/media/illustrations/unitedpalms-1/1.png" class="mw-100 mh-300px theme-light-show" alt="">
							<img src="/assets/theme/media/illustrations/unitedpalms-1/1-dark.png" class="mw-100 mh-300px theme-dark-show" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
		
    <div class="modal fade" id="kt_modal_upgrade_plan" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered modal-xxl">
            <div class="modal-content rounded">
                <div class="modal-header justify-content-end border-0 p-0">
                    <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" ::aria-label="$t('close')" ref="closeModal">
                        <span class="svg-icon svg-icon-1 text-hover-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                    transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                    transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="modal-body pt-1"> <Upgrade ref="UpgradeModal"/> </div>
            </div>
        </div>
    </div>
  </div>  
</template>

<script>
import Upgrade from '../components/parts/Upgrade.vue';
import axios from 'axios' 
import moment from 'moment';
export default {
	name: "LicenceExpired",
	data() {
		return {
			userData: this.$getUser(),
			pendingLicencesList: [],
		};
	},
	components: {
		Upgrade
	},
	computed:{
		previewDate(){
			return (value)=>{
				if (value) {
					return moment(new Date(value)).format('DD.MM.YYYY')
				}
			}
		}
	},
	methods: {
		openUpgradeModal(isProceedPayment, item) {
			if(isProceedPayment) {
				this.$refs.UpgradeModal.onCompletePayment(item);
			} else {
				this.$refs.UpgradeModal.initializeComponent();
			}
		},
		getData() {
			const parameters = {
				session_id: this.$getUser().session_id
			};  
			axios.post('/api/Lic/GetPendingActions', parameters, {'Content-Type': 'application/json'})
			.then((response) => {
			if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
				this.pendingLicencesList = response.data;
			}
			})
			.catch((error) => {
				console.error(error);
			});
		},
		onCancelLicenceRequest(item) {        
			this.$swal.fire({
				title: this.$t('are_you_sure_you_want_to_cancel_this_request'),
				confirmButtonColor: "#f1416c",
				showDenyButton: false,
				showCancelButton: true,
			cancelButtonText: this.$t('cancel'),
				confirmButtonText: this.$t('cancel_request'),
				icon: 'info'
			})
			.then((result) => {
				if (result.isConfirmed) {
					this.$Progress.start();
					const params = {
						session_id: this.$getUser().session_id, 
						transaction_id: item.id,
						strsubid: ''
					};   
					const that = this;
					axios.post('api/Lic/CancelLicenceRequest', params, {'Content-Type': 'application/json'})
					.then((response) => {
						if(response.data.error == null || response.data.error == 'undefined' || response.data.error == '') {
						this.$Progress.finish();
						this.$signOutWithTimer(this.$t('session-terminated'), this.$t('upgrade_request_has_been_cancelled'));
						}
					})
					.catch(() => {
						that.$Progress.finish();
					});    
				}
			}); 
		}
	},
	created() {
		this.getData();
		
		this.emitter.on("isExistPendingLicenceRequest", () => {
			this.userData = this.$getUser();
		});
	}
};
</script>
